import selectOptions from './selectOptions.json';
import employeePays from './employeePays.json';
import employeePaysAsync from './employeePaysAsync.json';
import employeeAttendances from './employeeAttendances.json';
import allowances from './allowances.json';
import allowanceItems from './allowanceItems.json';
import employeeAsync from './employeeAsync.json';
import dashboard from './dashboard.json';
import users from './users.json';
import searchFrom from './searchForm.json';
import employees from './employees.json';

export default {
  reducers: {
    ...selectOptions,
    ...employeePays,
    employeePaysAsync,
    ...employeeAsync,
    ...allowances,
    ...allowanceItems,
    employeeAttendances,
    dashboard,
    ...users,
    ...searchFrom,
    ...employees
  }
};
